import { useUpdateShippingLocationGroupMutation } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import Action from '@/gf/components/Action'
import CloseModalButton from '@/gf/components/CloseModalButton'
import Modal from '@/gf/components/ModalNext'
import Field from '@/gf/components/next/forms/Field'
import TextInput from '@/gf/components/next/forms/TextInput'
import useMsgs from '@/gf/hooks/useMsgs'
import { ApolloError } from '@apollo/client'
import { useState } from 'react'
import type { LocationGroup } from './index'

const EditLocationGroupModal = ({
  locationGroup,
  onClose,
  onSuccess,
}: {
  locationGroup: LocationGroup
  onClose: () => void
  onSuccess: () => void
}) => {
  const client = useGqlClient()
  const [_, msgr] = useMsgs()
  const [updateGroup] = useUpdateShippingLocationGroupMutation({ client })
  const [name, setName] = useState(locationGroup.name)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!name.trim()) {
      msgr.add('Please enter a location group name', 'negative')
      return
    }

    if (name.trim() === locationGroup.name) {
      onClose()
      return
    }

    setIsSubmitting(true)

    try {
      await updateGroup({
        variables: {
          id: locationGroup.id,
          name: name.trim(),
        },
      })

      onSuccess()
    } catch (err) {
      const error = err as ApolloError
      const message = error.graphQLErrors.reduce((acc, error) => `${acc}${error.message}`, '')
      msgr.add(message || 'Failed to update location group', 'negative')
      setIsSubmitting(false)
    }
  }

  return (
    <Modal onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-900">Edit Location Group</h3>
            <CloseModalButton onClick={onClose} />
          </div>

          <Field label="Location Group Name" htmlFor="groupName">
            <TextInput id="groupName" value={name} setValue={setName} autoFocus required />
          </Field>

          <div className="mt-6 flex justify-end gap-3">
            <Action.S onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Action.S>
            <Action.P color="blue" type="submit" performing={isSubmitting} disabled={isSubmitting}>
              Save
            </Action.P>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default EditLocationGroupModal
